module.exports = __webpack_public_path__ + "PC/img/con-fwlc-bg.51a05bbf.jpg";